// Libraries
var React = require('react');
var copy = require('copy-to-clipboard');

// Styles
require('./InlineShare.scss');

// Assets
var xIcon = require('images/x.svg');
var facebookIcon = require('images/fb.svg');
var linkIcon = require('images/link.svg');

class InlineShareModule extends React.Component {
	constructor(props) {
		super(props);

		this.baseXUrl = "https://x.com/intent/tweet?url=";
		this.baseFacebookUrl = "https://www.facebook.com/sharer/sharer.php?u=";

		this.state = {
			hideCopiedMessage: true,
			title: this.props.data.title || "",
			description: this.props.data.description || "",
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null
		}
	}

	handleClick(type, event) {
		let fullShareText =  this.state.title + (this.state.title.length > 0 ? " " : "") + this.state.description;

		let shareMethod;

		if(type === "facebook") {

			shareMethod = 'Facebook';

			const object = {
				'og:url': this.props.data.url,
				'og:title': this.state.title,
				'og:description': this.state.description,
			}
			if (this.props.data.imageUrl !== null) {
				object['og:image'] = this.props.data.imageUrl;
			}

			window.FB.ui({
				method: 'share_open_graph',
				action_type: 'og.shares',
				action_properties: JSON.stringify({ object })
			}, (res) => {});

		}

		if(type === "x") {

			shareMethod = 'Twitter'; // Used in event tracking it seems, so did not change to X

			window.open(this.baseXUrl + this.props.data.url + "&text=" + fullShareText, "X", "menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,centerscreen=yes,chrome=yes,height=400,width=600");

		}

		if(type === "link") {

			shareMethod = 'Link';

			this.setState({ hideCopiedMessage: false }, () => {
				setTimeout(() => {
					this.setState({ hideCopiedMessage: true });
				}, 1000);
			});
			copy(fullShareText + (fullShareText.length > 0 ? " " : "") + this.props.data.url);

		}

		if (
			this.state.defaultMParticleEventObject !== null &&
			window.articleMParticleEventObject !== null
		) {

			const eventDataMerged = {...this.state.defaultMParticleEventObject, ...window.articleMParticleEventObject };
			eventDataMerged.event = 'content_shared';
			eventDataMerged.share_method = shareMethod;

			window.dataLayer.push(eventDataMerged);

		}


	}

	render() {
		return (		
			<div className="InlineShare">
				<ul>
					<li className="InlineShare__icon InlineShare__icon--facebook"><button tabIndex={this.props.tabIndex} onClick={this.handleClick.bind(this, "facebook")}><img src={facebookIcon} alt="Share this page via Facebook" /></button></li>
					<li className="InlineShare__icon"><button tabIndex={this.props.tabIndex} onClick={this.handleClick.bind(this, "x")}><img src={xIcon} alt="Share this page via X (formerly Twitter)" /></button></li>
					<li className="InlineShare__icon"><button tabIndex={this.props.tabIndex} onClick={this.handleClick.bind(this, "link")}><img src={linkIcon} alt="Copy a link to this page" /></button></li>
				</ul>
				<span className={this.state.hideCopiedMessage ? "hide" : ""}>Copied to clipboard</span>
			</div>
		)
	}
}

module.exports = InlineShareModule;



// WEBPACK FOOTER //
// ./src/common/InlineShare/InlineShareModule.js